module.exports = __webpack_public_path__ + "assets/gazeta.3c3db02ef8c9ad495ba375dbeddf2c5aaa532519161b34ff6954e3023d95a9ed.png";